/**
 * MDI icon catalog organised by category
 * Used by MdiIconPicker for device/room type icon selection
 */

export const MDI_CDN_BASE_URL = "https://cdn.jsdelivr.net/npm/@mdi/svg@7.4.47/svg";

export const ICON_GROUPS = [
  {
    label: "Lights & Lighting",
    icons: [
      "mdiLightbulb", "mdiLightbulbOutline", "mdiLightbulbOn", "mdiLightbulbOnOutline",
      "mdiLightbulbOff", "mdiLightbulbOffOutline", "mdiLightbulbGroup", "mdiLightbulbGroupOutline",
      "mdiCeilingLight", "mdiCeilingLightOutline", "mdiCeilingLightMultiple", "mdiCeilingLightMultipleOutline",
      "mdiFloorLamp", "mdiFloorLampDual", "mdiFloorLampDualOutline", "mdiFloorLampOutline",
      "mdiDeskLamp", "mdiDeskLampOutline", "mdiDeskLampOn", "mdiDeskLampOff",
      "mdiWallLamp", "mdiWallLampVariant", "mdiWallLampVariantOutline", "mdiWallLampOutline",
      "mdiLedStrip", "mdiLedStripVariant", "mdiLamp", "mdiLampOutline",
      "mdiStringLights", "mdiStringLightsOff", "mdiLantern", "mdiLanternOff",
    ],
  },
  {
    label: "HVAC & Climate",
    icons: [
      "mdiAirConditioner",
      "mdiFan", "mdiFanOff", "mdiFanAlert", "mdiFanClock", "mdiFanChevronUp", "mdiFanChevronDown",
      "mdiFanPlus", "mdiFanMinus", "mdiFanSpeed1", "mdiFanSpeed2", "mdiFanSpeed3",
      "mdiThermometer", "mdiThermometerHigh", "mdiThermometerLow", "mdiThermometerAuto",
      "mdiThermometerOff", "mdiThermometerAlert", "mdiThermometerCheck",
      "mdiThermostat", "mdiThermostatBox", "mdiThermostatCog",
      "mdiRadiator", "mdiRadiatorDisabled", "mdiRadiatorOff", "mdiRadiatorCog",
      "mdiHeatPump", "mdiHeatPumpOutline",
      "mdiTemperatureCelsius", "mdiTemperatureFahrenheit",
      "mdiAirFilter", "mdiAirPurifier", "mdiAirPurifierOff",
      "mdiSnowflake", "mdiSnowflakeOff", "mdiSnowflakeMelt", "mdiSnowflakeAlert",
      "mdiFireplace", "mdiFireplaceOff",
      "mdiHumidity", "mdiHumidifier", "mdiHumidifierOff",
    ],
  },
  {
    label: "Security & Access",
    icons: [
      "mdiLock", "mdiLockOpen", "mdiLockOutline", "mdiLockOpenOutline",
      "mdiLockAlert", "mdiLockAlertOutline", "mdiLockCheck", "mdiLockCheckOutline",
      "mdiLockPlus", "mdiLockPlusOutline", "mdiLockReset",
      "mdiDoorOpen", "mdiDoorClosed", "mdiDoorSlidingOpen", "mdiDoorSlidingClosed",
      "mdiWindowOpen", "mdiWindowClosed", "mdiWindowOpenVariant", "mdiWindowClosedVariant",
      "mdiWindowShutter", "mdiWindowShutterOpen", "mdiWindowShutterAlert",
      "mdiGarage", "mdiGarageOpen", "mdiGarageAlert", "mdiGarageVariant", "mdiGarageVariantClosed",
      "mdiCamera", "mdiCameraOff", "mdiCameraHome", "mdiCameraHomeOutline",
      "mdiCctv", "mdiCctvOff",
      "mdiShield", "mdiShieldOff", "mdiShieldCheck", "mdiShieldCheckOutline",
      "mdiShieldAlert", "mdiShieldAlertOutline", "mdiShieldHome", "mdiShieldHomeOutline",
      "mdiShieldLock", "mdiShieldLockOutline", "mdiShieldKey", "mdiShieldKeyOutline",
      "mdiAlarm", "mdiAlarmOff", "mdiAlarmCheck", "mdiAlarmPlus",
      "mdiAlarmLight", "mdiAlarmLightOutline", "mdiAlarmLightOff",
      "mdiAlarmPanel", "mdiAlarmPanelOutline",
      "mdiMotionSensor", "mdiMotionSensorOff", "mdiMotionSensorOutline",
      "mdiSmokeDetector", "mdiSmokeDetectorAlert", "mdiSmokeDetectorVariant", "mdiSmokeDetectorVariantAlert",
      "mdiVideoCamera", "mdiVideoCameraOff",
      "mdiDoorbell", "mdiDoorbellVideo", "mdiDoorbellVideoOff",
      "mdiKey", "mdiKeyVariant", "mdiKeyWireless", "mdiKeychain",
    ],
  },
  {
    label: "Appliances",
    icons: [
      "mdiTelevision", "mdiTelevisionPlay", "mdiTelevisionOff", "mdiTelevisionClassic",
      "mdiTelevisionClassicOff", "mdiTelevisionAmbientLight",
      "mdiRefrigerator", "mdiRefrigeratorOutline", "mdiRefrigeratorOff",
      "mdiRefrigeratorVariant", "mdiRefrigeratorVariantOutline",
      "mdiWashingMachine", "mdiWashingMachineOff", "mdiWashingMachineAlert",
      "mdiDishwasher", "mdiDishwasherAlert", "mdiDishwasherOff",
      "mdiOven", "mdiOvenOff",
      "mdiMicrowave", "mdiMicrowaveOff",
      "mdiCoffeeMaker", "mdiCoffeeMakerOff", "mdiCoffeeMakerOutline",
      "mdiCoffeeMakerCheck", "mdiCoffeeMakerCheckOutline",
      "mdiCoffee", "mdiCoffeeOutline", "mdiCoffeeOff",
      "mdiRobotVacuum", "mdiRobotVacuumVariant", "mdiRobotVacuumVariantAlert",
      "mdiRobotMower", "mdiRobotMowerOutline",
      "mdiIron", "mdiIronBoard", "mdiIronOutline",
      "mdiHairDryer", "mdiHairDryerOutline",
      "mdiBlender", "mdiBlenderOutline",
      "mdiToaster", "mdiToasterOven", "mdiToasterOvenOff",
      "mdiVacuum", "mdiVacuumOutline",
    ],
  },
  {
    label: "Audio & Entertainment",
    icons: [
      "mdiSpeaker", "mdiSpeakerOff", "mdiSpeakerMultiple", "mdiSpeakerMultipleOff",
      "mdiSpeakerWireless", "mdiSpeakerBluetooth", "mdiSpeakerMessage",
      "mdiRemote", "mdiRemoteOff", "mdiRemoteTv", "mdiRemoteTvOff",
      "mdiMicrophone", "mdiMicrophoneOff", "mdiMicrophoneVariant", "mdiMicrophoneVariantOff",
      "mdiMicrophoneOutline",
      "mdiGamepad", "mdiGamepadVariant", "mdiGamepadVariantOutline",
      "mdiConsoleController",
      "mdiMusic", "mdiMusicNote", "mdiMusicNoteOff", "mdiMusicNoteOutline",
      "mdiVolumeMute", "mdiVolumeOff", "mdiVolumeLow", "mdiVolumeMedium", "mdiVolumeHigh",
      "mdiCast", "mdiCastOff", "mdiCastConnected", "mdiCastVariant",
      "mdiRadio", "mdiRadioOff", "mdiRadioTower", "mdiAntenna",
      "mdiRecord", "mdiRecordPlayer",
      "mdiProjector", "mdiProjectorOff", "mdiProjectorScreen",
    ],
  },
  {
    label: "Power & Electrical",
    icons: [
      "mdiPower", "mdiPowerOff", "mdiPowerOn", "mdiPowerStandby", "mdiPowerSleep", "mdiPowerCycle",
      "mdiPowerPlug", "mdiPowerPlugOff", "mdiPowerPlugOutline", "mdiPowerPlugOffOutline",
      "mdiPowerPlugBattery",
      "mdiPlug", "mdiPlugOff", "mdiPlugOutline", "mdiPlugCog",
      "mdiElectricSwitch", "mdiElectricSwitchClosed",
      "mdiToggleSwitch", "mdiToggleSwitchOff", "mdiToggleSwitchOffOutline", "mdiToggleSwitchOutline",
      "mdiDimmerSwitch", "mdiDimmerSwitchOff",
      "mdiCircuitBreaker", "mdiCircuitBreakerOff",
      "mdiFlash", "mdiFlashOff", "mdiFlashOutline", "mdiFlashAlert", "mdiFlashAlertOutline",
      "mdiLightningBolt", "mdiLightningBoltOutline", "mdiLightningBoltCircle",
      "mdiTransformerTransmission",
      "mdiOutlet", "mdiOutletOutline", "mdiOutletWireless",
      "mdiTimer", "mdiTimerOff", "mdiTimerOutline", "mdiTimerSand", "mdiTimerSandEmpty",
    ],
  },
  {
    label: "Water & Gas",
    icons: [
      "mdiWater", "mdiWaterOff", "mdiWaterAlert", "mdiWaterCheck", "mdiWaterMinus", "mdiWaterPlus",
      "mdiWaterPercent", "mdiWaterPercentAlert",
      "mdiWaterPump", "mdiWaterPumpOff",
      "mdiWaterBoiler", "mdiWaterBoilerOff", "mdiWaterBoilerAuto", "mdiWaterBoilerAlertOutline",
      "mdiWaterHeater",
      "mdiGasCylinder", "mdiGasBurner", "mdiGasStation",
      "mdiPump", "mdiPumpOff",
      "mdiValve", "mdiValveClosed", "mdiValveOpen",
      "mdiPipe", "mdiPipeDisconnected", "mdiPipeLeak",
      "mdiShowerHead", "mdiShower", "mdiShowerHeadDown",
      "mdiFaucet", "mdiFaucetVariant",
      "mdiPool", "mdiHotTub",
      "mdiLeaf", "mdiLeafOff", "mdiLeafMaple", "mdiLeafCircle",
    ],
  },
  {
    label: "Solar & Energy",
    icons: [
      "mdiSolarPanel", "mdiSolarPanelLarge",
      "mdiBattery", "mdiBattery10", "mdiBattery20", "mdiBattery30", "mdiBattery40",
      "mdiBattery50", "mdiBattery60", "mdiBattery70", "mdiBattery80", "mdiBattery90",
      "mdiBatteryCharging", "mdiBatteryCharging10", "mdiBatteryCharging20",
      "mdiBatteryCharging30", "mdiBatteryCharging40", "mdiBatteryCharging50",
      "mdiBatteryCharging60", "mdiBatteryCharging70", "mdiBatteryCharging80",
      "mdiBatteryCharging90", "mdiBatteryChargingOutline",
      "mdiBatteryHigh", "mdiBatteryMedium", "mdiBatteryLow",
      "mdiBatteryAlert", "mdiBatteryAlertVariantOutline",
      "mdiMeterElectric", "mdiMeterElectricOutline",
      "mdiMeterGas", "mdiMeterGasOutline",
      "mdiMeterWater", "mdiMeterWaterOutline",
      "mdiGeneratorStationary", "mdiGenerator",
      "mdiWindPower", "mdiWindPowerOutline",
      "mdiEarth", "mdiEarthOff",
    ],
  },
  {
    label: "Window Treatments & Blinds",
    icons: [
      "mdiBlinds", "mdiBlindsOpen", "mdiBlindsHorizontal", "mdiBlindsHorizontalClosed",
      "mdiBlindsVertical", "mdiBlindsVerticalClosed",
      "mdiCurtains", "mdiCurtainsOpen",
      "mdiRollerShade", "mdiRollerShadeClosed",
      "mdiAwningSun", "mdiAwning", "mdiAwningOutline",
    ],
  },
  {
    label: "Networking & Connectivity",
    icons: [
      "mdiWifi", "mdiWifiOff", "mdiWifiStrength1", "mdiWifiStrength2", "mdiWifiStrength3",
      "mdiWifiStrength4", "mdiWifiCog", "mdiWifiAlert", "mdiWifiCheck", "mdiWifiLock",
      "mdiWifiLockOpen", "mdiWifiArrowLeft", "mdiWifiArrowRight",
      "mdiBluetooth", "mdiBluetoothOff", "mdiBluetoothConnect", "mdiBluetoothTransfer",
      "mdiBluetoothAudio", "mdiBluetoothSettings", "mdiBluetoothSearching",
      "mdiRouter", "mdiRouterWireless", "mdiRouterWirelessOff", "mdiRouterWirelessSettings",
      "mdiHub", "mdiHubOutline",
      "mdiEthernet", "mdiEthernetCable", "mdiEthernetCableOff",
      "mdiAccessPoint", "mdiAccessPointOff", "mdiAccessPointCheck",
      "mdiZigbee", "mdiZwave",
      "mdiSignalCellularOutline", "mdiSignalCellular1", "mdiSignalCellular2", "mdiSignalCellular3",
    ],
  },
  {
    label: "Environmental Sensors",
    icons: [
      "mdiWaterPercent", "mdiHumidity",
      "mdiSmog", "mdiSmogOutline",
      "mdiMolecule", "mdiMoleculeCo2", "mdiMoleculeCo",
      "mdiNaturePeople", "mdiNature",
      "mdiWeatherSunny", "mdiWeatherSunnyOff", "mdiWeatherCloudy", "mdiWeatherPartlyCloudy",
      "mdiWeatherRainy", "mdiWeatherPouring", "mdiWeatherWindy", "mdiWeatherWindyVariant",
      "mdiWeatherSnowy", "mdiWeatherSnowyHeavy", "mdiWeatherFog", "mdiWeatherHail",
      "mdiWeatherLightning", "mdiWeatherLightningRainy", "mdiWeatherNight",
      "mdiSunThermometer", "mdiSunThermometerOutline",
      "mdiSunAngle", "mdiSunCompass", "mdiSunSnowflakeVariant",
      "mdiFire", "mdiFireAlert", "mdiFireOff", "mdiFireProtector",
      "mdiFlood", "mdiFloodAlert",
      "mdiLeafOff", "mdiLeaf",
      "mdiPressureHigh", "mdiPressureLow",
      "mdiCrosshairs", "mdiCrosshairsGps",
    ],
  },
  {
    label: "Home & Rooms",
    icons: [
      "mdiHome", "mdiHomeOutline", "mdiHomeModern", "mdiHomeCity", "mdiHomeCityOutline",
      "mdiHomeMinus", "mdiHomePlus", "mdiHomeVariant", "mdiHomeVariantOutline",
      "mdiHomeAlert", "mdiHomeAlertOutline", "mdiHomeCircle", "mdiHomeCircleOutline",
      "mdiHomeAutomation", "mdiHomeFlood", "mdiHomeLock", "mdiHomeLockOpen",
      "mdiHomeMapMarker", "mdiHomeAccount", "mdiHomeHeart", "mdiHomeHeartOutline",
      "mdiHomeSwitch", "mdiHomeSwitchOutline", "mdiHomeImportOutline", "mdiHomeExportOutline",
      "mdiOfficeBuilding", "mdiOfficeBuildingOutline", "mdiOfficeBuildingMarker",
      "mdiStorefront", "mdiStore", "mdiFactory",
      "mdiSofa", "mdiSofaOutline", "mdiSofaSingle", "mdiSofaSingleOutline",
      "mdiBed", "mdiBedOutline", "mdiBedKing", "mdiBedKingOutline", "mdiBedDouble", "mdiBedDoubleOutline",
      "mdiBath", "mdiBathOutline",
      "mdiTable", "mdiTableFurniture", "mdiChair",
    ],
  },
  {
    label: "Devices & Hardware",
    icons: [
      "mdiDevices",
      "mdiController", "mdiControllerClassic", "mdiControllerClassicOutline",
      "mdiChip", "mdiCpu32Bit", "mdiCpu64Bit",
      "mdiRaspberryPi", "mdiArduino",
      "mdiServer", "mdiServerNetwork", "mdiServerNetworkOff", "mdiServerOff",
      "mdiDesktopComputer", "mdiLaptop", "mdiLaptopOff", "mdiTablet", "mdiTabletOff",
      "mdiCellphone", "mdiCellphoneOff", "mdiCellphoneWireless",
      "mdiPrinter", "mdiPrinterOff", "mdiPrinterWireless",
      "mdiKeyboard", "mdiMouse", "mdiMonitor", "mdiMonitorOff",
      "mdiNas",
      "mdiUsb", "mdiUsbPort",
      "mdiSmartCardOff", "mdiSmartCard",
      "mdiTouchscreen", "mdiTouchscreenOff",
      "mdiSensorSmoke", "mdiSensorCo", "mdiSensorOccupancy",
    ],
  },
  {
    label: "General & Controls",
    icons: [
      "mdiCog", "mdiCogOutline", "mdiCogOff", "mdiCogOffOutline",
      "mdiSettings", "mdiSliderHorizontal", "mdiSliderHorizontalCircle",
      "mdiTune", "mdiTuneVertical", "mdiTuneVerticalVariant",
      "mdiKnob",
      "mdiStar", "mdiStarOutline", "mdiStarOff", "mdiStarHalf", "mdiStarHalfFull",
      "mdiHeart", "mdiHeartOutline", "mdiHeartOff", "mdiHeartOffOutline",
      "mdiCheck", "mdiCheckAll", "mdiCheckCircle", "mdiCheckCircleOutline",
      "mdiClose", "mdiCloseCircle", "mdiCloseCircleOutline",
      "mdiPlus", "mdiPlusCircle", "mdiPlusCircleOutline",
      "mdiMinus", "mdiMinusCircle", "mdiMinusCircleOutline",
      "mdiRefresh", "mdiRefreshCircle",
      "mdiInformation", "mdiInformationOutline",
      "mdiAlert", "mdiAlertOutline", "mdiAlertCircle", "mdiAlertCircleOutline",
      "mdiHelpCircle", "mdiHelpCircleOutline",
      "mdiMap", "mdiMapMarker", "mdiMapMarkerOutline", "mdiMapMarkerOff",
      "mdiCalendar", "mdiCalendarClock", "mdiCalendarCheck",
      "mdiClock", "mdiClockOutline", "mdiClockAlert", "mdiClockAlertOutline",
      "mdiSchedule", "mdiHistory",
    ],
  },
];
